export default __webpack_public_path__ + "static/media/sublevel2_4.0bb22c05.webp";